<script>
import ActualitiesService from '@/services/actualities'
import EnvironmentUtils from '@/utils/environmentUtils'
import ScrollableContent from '@/views/ScrollableContent'

export default
{
    name: 'read-actuality',

    created ()
    {
        if (this.$route.params.id)
        {
            ActualitiesService.fetchActualityById(EnvironmentUtils.cityId, this.$route.params.id, null).then(async fetchedActuality =>
            {
                await this.$store.commit('actualities/updateActualityList', [fetchedActuality])
                this.actuality = await this.$store.getters.actualities.getActualityById(this.$route.params.id)

                const i = new Image()
                i.onload = () =>
                {
                    console.log('Image loaded')
                    this.backgroundImage = i.src
                }
                i.src = this.actuality.imageUrl
                console.log('Loading real actuality', this.actuality, 'image', i.src)
            })
            .catch(e =>
            {
                console.error('Actuality', this.$route.params.id, 'does not exist', e)
                this.$router.push('/actualities')
            })
        }

        const { whileFetchingImage } = this.$route.query
        this.backgroundImage = (this.actuality || {}).imageUrl

        if (whileFetchingImage)
        {
            console.log('Using fetching image placeholder', whileFetchingImage, 'for actuality', this.actuality)
            this.backgroundImage = whileFetchingImage
        }
    },

    render () 
    {
        if (this.actuality == undefined) return;

        const iconItems =
        [
            <inline-svg fill='white' src={require('@/assets/img/heart.svg')} 
                on-click={this.onHeartIconClicked} id='heart' add-class={this.isSavedAsFavorite ? 'active' : ''} />
        ]

        return (
            <div id='read-actuality-view'>
                <scrollable-content background-image={this.backgroundImage} icon-items={iconItems} back-path='/actualities'>
                    <span id='title'>{ this.actuality.title }</span>
                    <div domPropsInnerHTML={this.actuality.content} />
                </scrollable-content>
            </div>
        )
    },

    data () 
    {
        return {
            backgroundImage: null,
            actuality: {},
        }
    },

    computed:
    {
        isSavedAsFavorite ()
        {
            return this.$store.state.favorites.actualities.includes(this.actuality.id)
        }
    },

    mounted ()
    {
    },


    methods:
    {
        onHeartIconClicked (e)
        {
            this.$store.commit('favorites/setActualityState', {actualityId: this.actuality.id, isFavorite: !this.isSavedAsFavorite})
            // this.$refs.iconsBar.style.height = 0
            // setTimeout(() => this.$refs.iconsBar.style.height =  '', 10)
        },
    },

    components:
    {
        ScrollableContent
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#read-actuality-view
{
    
}
</style>



// WEBPACK FOOTER //
// src/views/ReadActuality.vue